import { CancelError, NetworkError } from './errors';

export const isError = (error: unknown): error is Error => {
  return error instanceof Error;
};

export const isNetworkError = (error: unknown): error is NetworkError => {
  return error instanceof NetworkError;
};

export const isCancelled = (error: unknown): error is CancelError => {
  return error instanceof CancelError;
};
